import type { ComponentProps } from "react";

import AtFlag from "./AtFlag";
import BeFlag from "./BeFlag";
import CzFlag from "./CzFlag";
import DeFlag from "./DeFlag";
import DkFlag from "./DkFlag";
import EeFlag from "./EeFlag";
import EsFlag from "./EsFlag";
import FiFlag from "./FiFlag";
import FrFlag from "./FrFlag";
import GrFlag from "./GrFlag";
import HrFlag from "./HrFlag";
import HuFlag from "./HuFlag";
import ItFlag from "./ItFlag";
import LtFlag from "./LtFlag";
import LvFlag from "./LvFlag";
import NlFlag from "./NlFlag";
import NoFlag from "./NoFlag";
import PlFlag from "./PlFlag";
import PtFlag from "./PtFlag";
import RoFlag from "./RoFlag";
import SeFlag from "./SeFlag";
import SiFlag from "./SiFlag";
import SkFlag from "./SkFlag";

type FlagProps = ComponentProps<"svg"> & {
  code: string;
};

export default function Flag({ code, ...props }: FlagProps) {
  switch (code) {
    case "at":
      return <AtFlag {...props} />;
    case "be":
      return <BeFlag {...props} />;
    case "cz":
      return <CzFlag {...props} />;
    case "de":
      return <DeFlag {...props} />;
    case "dk":
      return <DkFlag {...props} />;
    case "ee":
      return <EeFlag {...props} />;
    case "es":
      return <EsFlag {...props} />;
    case "fi":
      return <FiFlag {...props} />;
    case "fr":
      return <FrFlag {...props} />;
    case "gr":
      return <GrFlag {...props} />;
    case "hr":
      return <HrFlag {...props} />;
    case "hu":
      return <HuFlag {...props} />;
    case "it":
      return <ItFlag {...props} />;
    case "lt":
      return <LtFlag {...props} />;
    case "lv":
      return <LvFlag {...props} />;
    case "nl":
      return <NlFlag {...props} />;
    case "no":
      return <NoFlag {...props} />;
    case "pl":
      return <PlFlag {...props} />;
    case "pt":
      return <PtFlag {...props} />;
    case "ro":
      return <RoFlag {...props} />;
    case "se":
      return <SeFlag {...props} />;
    case "si":
      return <SiFlag {...props} />;
    case "sk":
      return <SkFlag {...props} />;
    default:
      return null;
  }
}
